import React, { useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";

import { Admin, ListGuesser, Resource, ShowGuesser } from "react-admin";
import jsonServerProvider from "ra-data-json-server";
import MyLayout from "../components/__common/MyLayout";

import { defaultTheme } from "react-admin";
import { createTheme } from "@material-ui/core/styles";

import merge from "lodash/merge";

import { antibiotics } from "./../components/antibiotics";
import { catalog_samples } from "./../components/catalog_samples";
import { culture_media } from "./../components/culture_media";
import { cultures } from "./../components/cultures";
import { isolates } from "./../components/isolates";
import { providers } from "./../components/providers";
import { samples } from "./../components/samples";
import { abricate } from "./../components/abricate";
import { storages } from "./../components/storages";
import { phages } from "./../components/phages";
import { phages_hosts } from "./../components/phages_hosts";


import { UserProfile } from "./../components/user-profile";

import { HttpError } from "react-admin";
import { Route } from "react-router-dom";
 import { UploadFile } from "../components/upload-file";
import { external_isolates } from "../components/external_isolates";
import { isolates_antibiotics_interpretations } from "../components/isolates_antibiotics_interpretations";
import { files } from "../components/files";
import { AwsFileList } from "../components/aws-files/AwsFilesList";
import { AwsFilesShow } from "../components/aws-files/AwsFilesShow";
import { AwsBucketsList } from "../components/aws-buckets/AwsBucketsList";

// https://material-ui.com/customization/default-theme/

/*
https://mui.com/customization/breakpoints/#default-breakpoints 
xs, extra-small: 0px
sm, small: 600px
md, medium: 900px
lg, large: 1200px
xl, extra-large: 1536px
*/

const myTheme = createTheme(
  merge({}, defaultTheme, {
    palette: {
      primary: {
        main: "#007DEC",
      },
      secondary: {
        main: "#F8F9FA",
        contrastText: "#000000",
        light: "#ff7961",
        dark: "#ba000d",
      },
      error: {
        main: "#DB324A",
      },
    },

    typography: {
      fontFamily: `"RobotoMono","Montserrat", sans-serif, "Helvetica", "Arial"`,
      fontSize: 11,
    },
  })
);

const PakuApp = () => {
  const [setMessage] = useState("");
  const { REACT_APP_SERVER_URL } = process.env;
  const { getAccessTokenSilently } = useAuth0();

  const fetchJson = async (url, options = {}) => {
    console.log("fetchJson", url, options);
    const requestHeaders =
      options.headers ||
      new Headers({
        Accept: "application/json",
      });
    if (
      !requestHeaders.has("Content-Type") &&
      !(options && options.body && options.body instanceof FormData)
    ) {
      requestHeaders.set("Content-Type", "application/json");
    }
    if (options.user && options.user.authenticated && options.user.token) {
      requestHeaders.set("Authorization", options.user.token);
    }
    const response = await fetch(url, { ...options, headers: requestHeaders });
    const text = await response.text();
    const o = {
      status: response.status,
      statusText: response.statusText,
      headers: response.headers,
      body: text,
    };
    let status = o.status,
      statusText = o.statusText,
      headers = o.headers,
      body = o.body;
    let json;
    try {
      json = JSON.parse(body);
    } catch (e) {
      // not json, no big deal
    }
    if (status < 200 || status >= 300) {
      return Promise.reject(
        new HttpError(
          (json && json.error && json.error.message) || (json.errors && json.errors[0] && json.errors[0].msg) || statusText,
          status,
          json
        )
      );
    }
    return Promise.resolve({
      status: status,
      headers: headers,
      body: body,
      json: json,
    });
  };

  const httpClient = async (url, options = {}) => {
    try {
      if (!options.headers) {
        options.headers = new Headers({ Accept: "application/json" });
      }
      const token = await getAccessTokenSilently();
      options.headers.set("Authorization", `Bearer ${token}`);
      return fetchJson(url, options);
    } catch (error) {
      setMessage(error.message);
    }
  };

  const dataProvider = jsonServerProvider(
    REACT_APP_SERVER_URL + "/api",
    httpClient
  );

  const myDataProvider = {
    ...dataProvider,
    
  }
  return (
    <Admin
      dataProvider={myDataProvider}
      layout={MyLayout}
      theme={myTheme}
      customRoutes={[
        <Route
          key="upload-file"
          path="/upload-file"
          component={UploadFile}
          exact
        />,
        <Route
          key="profile"
          path="/userprofile"
          component={UserProfile}
          exact
        />,
      ]}
    >
      {/* Analitycs */}

      {/* General */}
      <Resource
        name="samples"
        {...samples}
        options={{ label: "Samples", menuParent: "general" }}
      />
       <Resource
        name="abricate"
        {...abricate}
        options={{ label: "Abricate", menuParent: "beta" }}
      /> 
      <Resource
        name="files"
        {...files}
        options={{ label: "Uploaded Files", menuParent: "beta" }}
      /> 
      <Resource
        name="aws/files"
        list={AwsFileList}
        show={AwsFilesShow}
        options={{ label: "Aws Uploaded Files", menuParent: "beta" }}
      /> 
      <Resource
        name="aws/buckets"
        list={AwsBucketsList}
        options={{ label: "Aws S3 Buckets", menuParent: "beta" }}
      /> 
      <Resource
        name="cultures"
        {...cultures}
        options={{ label: "Cultures", menuParent: "general" }}
      />
      <Resource
        name="isolates"
        {...isolates}
        options={{ label: "Isolates", menuParent: "general" }}
      />

      <Resource
        name="external_isolates"
        {...external_isolates}
        options={{ label: "External Isolates", menuParent: "general" }}
      />

      <Resource
        name="phages"
        {...phages}
        options={{ label: "Phages", menuParent: "general" }}
      />



      {/* Maintence */}

      <Resource
        name="antibiotics"
        {...antibiotics}
        options={{ label: "Antibiotics", menuParent: "maintence" }}
      />

      <Resource
        name="providers"
        {...providers}
        options={{ label: "Providers", menuParent: "maintence" }}
      />

      <Resource
        name="catalog_samples"
        {...catalog_samples}
        options={{ label: "Catalog Samples", menuParent: "maintence" }}
      />
      <Resource
        name="culture_media"
        {...culture_media}
        options={{ label: "Culture Media", menuParent: "maintence" }}
      />
      <Resource
        name="storages"
        {...storages}
        options={{ label: "Storages", menuParent: "maintence" }}
      />


      {/* Reports */}
      <Resource
        name="phages_hosts"
        {...phages_hosts}
        options={{ label: "Host Range", menuParent: "reports", }}
      />
      <Resource
        name="isolates_antibiotics_interpretations"
        {...isolates_antibiotics_interpretations}
        options={{
          label: "ATB Interpretations",
          menuParent: "reports",
        }}
      />

    </Admin>
  );
};

export default PakuApp;
